export default __webpack_public_path__ + "static/csv/HomeTiles.b34464f0.csv";